import { connect } from 'react-redux';
import PindahUnit from '../../../views/Akademi/DataKelas/PindahUnit.view';
import { getUnitsOptions, getParamOptionsAcademics, getNewStudentOptions } from '../../../states/thunks/options.thunk';
import {
  listPindahUnitSiswa, savePindahUnits, getClassDiv, getClassData, getSwitchUnit,
} from '../../../states/thunks/academics.thunk';


function mapStateToProps(state) {
  return {
    user: state.user,
    classes: state.options.classes,
    levels: state.options.levels,
    result: state.result,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    getUnitsOptions: payload => dispatch(getUnitsOptions(payload)),
    getParamOptionsAcademics: (payload, type) => dispatch(getParamOptionsAcademics(payload, type)),
    handleGetClassDiv: payload => dispatch(getClassDiv(payload)),
    handleGetClassData: payload => dispatch(getClassData(payload)),
    handleListPindahUnitSiswa: (payload, goback) => dispatch(listPindahUnitSiswa(payload, goback)),
    handlesavePindahUnits: (payload, goback) => dispatch(savePindahUnits(payload, goback)),
    getNewStudentOptions: payload => dispatch(getNewStudentOptions(payload)),
    handleGetSwitchUnit: payload => dispatch(getSwitchUnit(payload)),

  };
}

export default connect(mapStateToProps, mapDispatchToProps)(PindahUnit);
